import axios from 'frontend/_config/axios'
import setupRouter from 'frontend/_setup/setupRouter/setupRouter'
import { ResourceService } from 'frontend/common/services/resource-service'
import { SimpleSelectService } from 'frontend/common/services/simple-select-service'

export class VehicleSourcesService extends ResourceService {
  constructor({
    eventSlug = setupRouter.currentRoute.value.params.eventSlug,
    baseUrl = `/events/${eventSlug}/vehicle_sources`,
    blocker,
    fetchError = 'Failed to fetch vehicle sources.',
    saveError = 'Failed to save vehicle source.',
    apiProvider = axios,
    selectService = new SimpleSelectService(baseUrl, {
      apiProvider,
      blocker,
      blockerKey: 'vehicle-sources',
    }),
  } = {}) {
    super({
      apiProvider,
      baseUrl,
      blocker,
      fetchError,
      saveError,
    })
    this.selectService = selectService
  }

  get getForSelect() {
    return () =>
      this.selectService.fetchOptions({
        fields: ['id', 'name'],
        path: `${this.selectService.baseUrl}/selection_index`,
      })
  }
}
